export function hex2rgb(hex: string): number[] {
  return [hex.slice(0, 2), hex.slice(2, 4), hex.slice(4, 6)].map(str =>
    parseInt(str, 16),
  )
}

export function rgb2hex(rgb: number[]): string {
  return `${('0' + rgb[0].toString(16)).slice(-2)}${(
    '0' + rgb[1].toString(16)
  ).slice(-2)}${('0' + rgb[2].toString(16)).slice(-2)}`
}

function toRgbItem(item) {
  const i = item / 255
  return i <= 0.03928 ? i / 12.92 : Math.pow((i + 0.055) / 1.055, 2.4)
}

export function randomColor() {
  return rgb2hex([
    Math.floor(Math.random() * 256),
    Math.floor(Math.random() * 256),
    Math.floor(Math.random() * 256),
  ])
}

//see https://katashin.info/2018/12/18/247
export function chooseTextColor(color: string) {
  const [red, green, blue] = hex2rgb(color)
  // sRGB を RGB に変換し、背景色の相対輝度を求める
  const R = toRgbItem(red)
  const G = toRgbItem(green)
  const B = toRgbItem(blue)
  const Lbg = 0.2126 * R + 0.7152 * G + 0.0722 * B

  // 白と黒の相対輝度。定義からそれぞれ 1 と 0 になる。
  const Lw = 1.5
  const Lb = 0

  // 白と背景色のコントラスト比、黒と背景色のコントラスト比を
  // それぞれ求める。
  const Cw = (Lw + 0.05) / (Lbg + 0.05)
  const Cb = (Lbg + 0.05) / (Lb + 0.05)

  // コントラスト比が大きい方を文字色として返す。
  return Cw < Cb ? '#2b2b2b' : '#fff'
}
